<template>
  <Collapse name="Información del Usuario" :opened="false" v-if="roomId && userInfo">
    <div class="is-fullwidth">
      <p>
        <span class="has-text-primary">Cédula: </span>{{ getProp("cedula") }}
      </p>
      <p>
        <span class="has-text-primary">Correo: </span>{{ getProp("email") }}
      </p>
      <p>
        <span class="has-text-primary">Trámite: </span>{{ getProp("process") }}
      </p>
    </div>
  </Collapse>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Collapse from "@/components/Collapse.vue";

export default {
  name: "user-cau",
  components: {
    Collapse,
  },
  props: {
    roomId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userInfo: null,
    };
  },
  async mounted() {
    await this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      try {
        if (this.roomId) {
          let response = await RepositoryFactory.integration.getBioByRoom({
            id: this.roomId,
          });
          this.userInfo = response.data ?? null;
        }
      } catch (error) {
        this.userInfo = null;
      }
    },
    getProp(name) {
      let userInfo = this.userInfo;
      return userInfo !== null ? userInfo[name] : "";
    },
  },
};
</script>
